module.exports = __webpack_public_path__ + "static/legacy_bn1@2x-2f5bb0895a4ac3eb58e22e264e76fd17.jpg";